module.exports = __webpack_public_path__ + "img/关于我们—招标代理.99fb7c77.jpg";